module.exports = __webpack_public_path__ + "static/screenshot-light-bb060f84ab8a14a5f4e711834356405b.png";